import { MouseEvent, ReactNode } from "react";
import {
    SizeVariants,
    tailwindSizeVariants,
    tailwindStyleVariants,
    VariantStyles,
} from "../types/styles";

// TODO: Consolidate `customWidth` and `size`
interface ButtonProps {
    id?: string;
    text?: string;
    children?: ReactNode;
    className?: string;
    customHeight?: string;
    customWidth?: string;
    onClick?: () => void;
    disabled?: boolean;
    href?: string;
    variant?: keyof VariantStyles;
    size?: keyof SizeVariants;
    justifyContent?: "justify-left" | "justify-center" | "justify-right";
}

function Button({
    id,
    text,
    children,
    className,
    customHeight,
    customWidth,
    onClick,
    disabled = false,
    href,
    variant = "primary",
    justifyContent = "justify-center",
    size = "lg",
}: ButtonProps) {
    const height = customHeight || "h-12";
    const width = customWidth || tailwindSizeVariants[size];

    // do not remove "[&:focus:not(:focus-visible)]:outline-hidden"
    // it is a workaround to suppress Bootstrap's ring for non-keyboard focuses
    const baseStyleClasses = `flex items-center tw-rounded-sm font-medium [&:focus:not(:focus-visible)]:outline-hidden ${height} ${width} ${className} ${justifyContent} ${tailwindStyleVariants.button.base[variant]}`;

    const content = children ?? text;

    // TODO: remove stopPropagation() here but will need to fix the Accordion component or set a flag?
    function handleClick(e: MouseEvent<HTMLButtonElement>): void {
        e.stopPropagation();
        onClick?.();
    }

    if (href) {
        return (
            <a
                id={id ? `${id}-btn` : "btn"}
                className={`hover:no-underline ${baseStyleClasses}`}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
            >
                {content}
            </a>
        );
    }

    return (
        <button
            id={id ? `${id}-btn` : "btn"}
            className={baseStyleClasses}
            onClick={handleClick}
            disabled={disabled}
        >
            {content}
        </button>
    );
}

export default Button;
